const productPage = document.querySelector('.template-product');
const productSection = document.querySelector('[data-section-type="product-template"]');
const sectionId = productSection?.dataset?.sectionId;
if (!productPage || !productSection || !sectionId) return;

let swatches;

initEventHandlers();

async function updatePageContents(targetUrl) {
  try {
    const response = await fetch(targetUrl);
    const html = await response.text();

    const parser = new DOMParser();
    const fetchedPage = parser.parseFromString(html, "text/html")?.querySelector('body');
    const variantSwitchStartEvent = new CustomEvent('product-variant-switch:start', {
      detail: { sectionId },
    });

    document.dispatchEvent(variantSwitchStartEvent);
    replaceElements(fetchedPage);
    initEventHandlers();

    const variantSwitchEndEvent = new CustomEvent('product-variant-switch:end', {
      detail: { sectionId },
    });
    document.dispatchEvent(variantSwitchEndEvent);
  } catch (err) {
    console.log('Failed to fetch page: ', err);
  }
}

function initEventHandlers() {
  document.addEventListener('click', function (e) {
    const swatch = e.target.classList.contains('siblings__swatch');
    if (!swatch) return;

    e.preventDefault();

    const targetUrl = e.target.href;
    if (!targetUrl) return;

    const retrieveFromURL = targetUrl + '?section_id=' + sectionId;

    history.pushState(null, "", targetUrl);
    updatePageContents(retrieveFromURL);
  });
}

function replaceElements(fetchedPage) {
  const galleryNew = fetchedPage?.querySelector('[data-product-single-media-slider]');
  const galleryThumbnailsNew = fetchedPage?.querySelector('[data-product-single-media-thumbs]')
  const productDetailsNew = fetchedPage?.querySelector('.product-single__details');
  const tryOnBtnNew = fetchedPage?.querySelector('.try-on-product-button');

  const gallery = document.querySelector('[data-product-single-media-slider]');
  const galleryThumbnails = document.querySelector('[data-product-single-media-thumbs]')
  const productDetails = document.querySelector('.product-single__details');
  const tryOnBtn = document.querySelector('.try-on-product-button');

  if (productDetails && productDetailsNew) productDetails.innerHTML = productDetailsNew?.innerHTML;
  if (gallery && galleryNew) gallery.innerHTML = galleryNew?.innerHTML;
  if (galleryThumbnails && galleryThumbnailsNew) galleryThumbnails.innerHTML = galleryThumbnailsNew?.innerHTML;
  if (tryOnBtn && tryOnBtnNew) tryOnBtn.outerHTML = tryOnBtnNew.outerHTML;
}